








import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
// import { thisYear } from "@/helpers/date-helper";

const COLORS = {
  PINK: "pink",
  GRAY: "gray",
  WHITE: "white"
};

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Heading
  },
  props: {
    graduateYear: {
      type: Number as PropType<Props["graduateYear"]>,
      required: true
    },
    short: {
      type: Boolean as PropType<Props["short"]>,
      default: false
    }
  },
  computed: {
    graduateYearText() {
      return this.short
        ? `${String(this.graduateYear).slice(-2)}年卒`
        : `${this.graduateYear}年卒`;
    },
    graduateYearClasses() {
      return ["graduateYearBadge", `graduateYearBadge--${this.badgeColor}`];
    },
    badgeColor() {
      // NOTE: 採用計画詳細とその他ページのバッジで色の統一が図れないため暫定的に白一色にする
      // 関連情報
      // https://onecareer.atlassian.net/browse/OCCA-1941
      // https://github.com/OneCareerJP/cloud/pull/601
      return COLORS.WHITE;

      /*const remainder =
        (thisYear() - this.graduateYear) % Object.keys(COLORS).length;
      if (remainder === 0) {
        return COLORS.PINK;
      } else if (remainder === 2) {
        return COLORS.WHITE;
      } else {
        return COLORS.GRAY;
      }*/
    }
  }
});
